'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TimeRange = require('MeetingsBase/models/TimeRange');

var _TimeRange2 = _interopRequireDefault(_TimeRange);

var _enums = require('MeetingsLib/constants/enums');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
  timeRange: new _TimeRange2.default(),
  type: _enums.UNAVAILABLE_REASONS.EVENT,
  relatedEventStartTime: null,
  ownerFirstName: null,
  ownerLastName: null,
  ownerEmail: null
};

exports.default = (0, _immutable.Record)(defaults, 'TimeRangeWithDescription');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/models/TimeRangeWithDescription.js
// module id = 389
// module chunks = 0